import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'

// 语言包
import zhCn from './langs/zh-CN'
import zhTw from './langs/zh-TW'
import enUs from './langs/en-US'
import elzhcn from 'element-ui/lib/locale/lang/zh-CN'
import elzhtw from 'element-ui/lib/locale/lang/zh-TW'
import elen from 'element-ui/lib/locale/lang/en'

Vue.use(VueI18n)

ElementLocale.i18n((key, val) => i18n.t(key, val))

export const messages = [
  // { key: 'en-US', name: 'English', message: { ...enUs, ...elen }, default: false },
  { key: 'zh-CN', name: '简体中文', message: { ...zhCn, ...elzhcn }, default: true },
  { key: 'zh-TW', name: '繁体中文', message: { ...zhTw, ...elzhtw }, default: false },
]

export const i18n = new VueI18n({
  legacy: false, // 设置为 false，启用 composition API 模式
  globalInjection: true,
  locale: localStorage.getItem('locale_lang') || 'zh-CN',
  fallbackLocale: 'zh-CN',
  formatFallbackMessages: true,
  messages: messages.reduce((p, c) => ((p[c.key] = c.message), p), {}),
  modifiers: {
    snakeCase: (str) => str.split(' ').join('_'),
  },
})

export default i18n
